import { render } from "./App.vue?vue&type=template&id=f8d3bf4c&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=f8d3bf4c&lang=css"

import exportComponent from "/Users/macosx/DEVELOPER/DevPersonal/08-3D WEBSITE/testing_babylonjs/babylonstart/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__